import styled from 'styled-components';

export const Container = styled.div`
	margin-bottom: 1.6rem;
`;
